// App.js
import './App.css';
import './css/Abas.css';
import 'react-tabs/style/react-tabs.css';

import { FaMapMarkedAlt, FaUser } from 'react-icons/fa';
import { Tabs, Tab, TabList } from 'react-tabs';

import MapaAtual from './components/MapaAtual';
import VisualizarTodosOsPontosNoMapa from './components/VisualizarTodosOsPontosNoMapa';
import MapaLevandoClienteAoDestino from './components/MapaLevandoClienteAoDestino';
import MapaIndoAteCliente from './components/MapaIndoAteCliente';
import MapaPilotoVindo from './components/MapaPilotoVindo';

import PaginaAdmTecnico from './paginas/PaginaAdmTecnico';

import CadastrarRepresentanteComercial from './paginas/CadastrarRepresentanteComercial';
import PaginaRepresentanteComercial from './paginas/PaginaRepresentanteComercial';

import PaginaPontoMototaxi from './paginas/PaginaPontoMototaxi';
import CadastrarPontoMototaxi from './paginas/CadastrarPontoMototaxi';
import AlterarSenhaPontoMototaxi from './paginas/AlterarSenhaPontoMototaxi';
import AlterarSenhaRepresentanteComercial from './paginas/AlterarSenhaRepresentanteComercial';
import ListarPontoMototaxi from './paginas/ListarPontoMototaxi';
import ListarLocalidadesAtendidas from './paginas/ListarLocalidadesAtendidas';
import CadastrarServicosAtendidos from './paginas/CadastrarServicosAtendidos';
import CadastrarLocalidadesAtendidas from './paginas/CadastrarLocalidadesAtendidas';


import PaginaPilotoMototaxi from './paginas/PaginaPilotoMototaxi';
import CadastrarPilotoMototaxi from './paginas/CadastrarPilotoMototaxi';
import ListarPilotoMototaxi from './paginas/ListarPilotoMototaxi';
import VisualizarPilotosNoMapa from './paginas/VisualizarPilotosNoMapa';

import VisualizarServicosDisponiveis from './paginas/VisualizarServicosDisponiveis';
import Login from './paginas/Login';
import Historico from './paginas/Historico';
import VisualizarDadosPonto from './paginas/VisualizarDadosPonto';
import VisualizarDadosViagem from './paginas/VisualizarDadosViagem';
import SolicitarServico from './paginas/SolicitarServico';

import logoMelgs from './assets/logo-melgs5.png';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate
} from 'react-router-dom';

// Tabs e conteúdo com abas
function AppTabs() {
  const location = useLocation();
  const navigate = useNavigate();

  // Rotas que pertencem à aba Conta
  const rotasConta = [
    '/conta',
    '/pagina-piloto-mototaxi',
    '/cadastrar-piloto-mototaxi',
    '/listar-piloto-mototaxi',
    '/pagina-ponto-mototaxi',
    '/cadastrar-ponto-mototaxi',
    '/listar-ponto-mototaxi',
    '/pagina-representante-comercial',
    '/cadastrar-representante-comercial',
    '/listar-localidades-atendidas',
    '/cadastrar-servicos-atendidos',
    '/visualizar-pilotos-no-mapa',
    '/alterar-senha-ponto-mototaxi',
    '/alterar-senha-representante-comercial',
    '/mapa-indo-ate-cliente'
  ];

  // Índice das abas
  let tabIndex = 0;
  if (rotasConta.some((r) => location.pathname.startsWith(r))) {
    tabIndex = 1; // agora Conta é índice 1 (Histórico removido)
  }

  const handleSelect = (index) => {
    if (index === 0) navigate('/');
    else if (index === 1) navigate('/conta');
  };

  return (
    <div
      className="App"
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      <style>{`
        .tab-ativa {
          background-color: #f0f8ff;
          color: #007bff !important;
          border: none !important;
        }
        .tab-ativa svg {
          color: #007bff;
        }
      `}</style>

      <header
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          padding: '0.3rem',
          backgroundColor: '#fff'
        }}
      >
        <img src={logoMelgs} alt="Logo Melgs" style={{ height: '50px' }} />
      </header>

      {/* Conteúdo principal */}
      <div
        className="conteudo-principal"
        style={{
          flex: 1,
          overflow: 'auto',
          padding: '10px',
          paddingBottom: '80px'
        }}
      >
        <Routes>
          <Route path="/" element={<VisualizarServicosDisponiveis />} />
          {/* Historico ainda existe como rota caso precise */}
          <Route path="/historico" element={<Historico />} />
          <Route path="/conta" element={<Login />} />
          <Route path="/mapa" element={<MapaAtual />} />
          <Route path="/visualizar-todos-os-pontos-no-mapa" element={<VisualizarTodosOsPontosNoMapa />} />
          <Route path="/mapa-piloto-vindo" element={<MapaPilotoVindo />} />
          <Route path="/mapa-levando-cliente-ao-destino" element={<MapaLevandoClienteAoDestino />} />
          <Route path="/mapa-indo-ate-cliente" element={<MapaIndoAteCliente />} />
          <Route path="/visualizar-dados-ponto/:id" element={<VisualizarDadosPonto />} />
          <Route path="/visualizar-dados-viagem/:id" element={<VisualizarDadosViagem />} />
          <Route path="/solicitar-servico/:id" element={<SolicitarServico />} />
          <Route path="/pagina-adm-tecnico" element={<PaginaAdmTecnico />} />
          <Route path="/cadastrar-representante-comercial" element={<CadastrarRepresentanteComercial />} />
          <Route path="/pagina-ponto-mototaxi" element={<PaginaPontoMototaxi />} />
          <Route path="/pagina-representante-comercial" element={<PaginaRepresentanteComercial />} />
          <Route path="/cadastrar-ponto-mototaxi" element={<CadastrarPontoMototaxi />} />
          <Route path="/alterar-senha-ponto-mototaxi" element={<AlterarSenhaPontoMototaxi />} />
          <Route path="/alterar-senha-representante-comercial" element={<AlterarSenhaRepresentanteComercial />} />
          <Route path="/cadastrar-servicos-atendidos" element={<CadastrarServicosAtendidos />} />
          <Route path="/cadastrar-localidades-atendidas" element={<CadastrarLocalidadesAtendidas />} />
          <Route path="/listar-ponto-mototaxi" element={<ListarPontoMototaxi />} />
          <Route path="/listar-localidades-atendidas" element={<ListarLocalidadesAtendidas />} />
          <Route path="/pagina-piloto-mototaxi" element={<PaginaPilotoMototaxi />} />
          <Route path="/cadastrar-piloto-mototaxi" element={<CadastrarPilotoMototaxi />} />
          <Route path="/listar-piloto-mototaxi" element={<ListarPilotoMototaxi />} />
          <Route path="/visualizar-pilotos-no-mapa" element={<VisualizarPilotosNoMapa />} />
        </Routes>
      </div>

      {/* Tabs fixadas no rodapé */}
      <Tabs
        selectedIndex={tabIndex}
        onSelect={handleSelect}
        style={{
          borderTop: '1px solid #ddd',
          background: '#fff'
        }}
      >
        <TabList
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            margin: 0,
            padding: '5px 0'
          }}
        >
          {/* Aba Início */}
          <Tab selectedClassName="tab-ativa" style={tabStyle}>
            <div style={tabContentStyle}>
              <FaMapMarkedAlt size={20} />
              <span>Início</span>
            </div>
          </Tab>

          {/* Aba Conta */}
          <Tab selectedClassName="tab-ativa" style={tabStyle}>
            <div style={tabContentStyle}>
              <FaUser size={20} />
              <span>Conta</span>
            </div>
          </Tab>
        </TabList>
      </Tabs>
    </div>
  );
}

const tabStyle = {
  flex: 1,
  textAlign: 'center',
  cursor: 'pointer',
  padding: '5px 0',
  outline: 'none',
  border: 'none'
};

const tabContentStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontSize: '12px'
};

// Roteador principal
function App() {
  return (
    <Router>
      <AppTabs />
    </Router>
  );
}

export default App;
